<script setup lang="ts">
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
</script>

<template>
  <FullPageCenteredLayout>The resource you're looking for does not exist.</FullPageCenteredLayout>
</template>
